import React, { useState } from 'react'

import style from './TmoRadioGroup.module.css'

function TmoRadioGroup({
  onChange,
  id,
  disabled,
  label,
  name,
  selectedValue,
  data,
  className,
  testId,
  ...rest
}) {
  const [value, setValue] = useState(data.defaultValue)

  return (
    <React.Fragment>
      {label && (
        <div className={style.label} htmlFor={id}>
          {label}
        </div>
      )}
      <div
        className={style.radio_group}
        aria-label={label}
        role='radiogroup'
        aria-labelledby={id}
        data-testid={testId}
      >
        {data.options.map((option, i) => (
          <div key={`options-${option}-${i}`}>
            <input
              type='radio'
              id={option}
              value={option}
              name={data.radioGrp}
              checked={option === value}
              disabled={disabled}
              aria-hidden={true}
              tabIndex={option === value ? '0' : '-1'}
              onChange={() => {
                setValue(option)
                onChange(option)
              }}
              data-testid={option}
              {...rest}
            />
            <label htmlFor={option}>{option}</label>
          </div>
        ))}
      </div>
    </React.Fragment>
  )
}

export default TmoRadioGroup
